import DynamicSubHeader from '@ifca-root/react-component/src/components/Header/DynamicSubHeader';
import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader';
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper';
import {
	Accordion,
	AccordionDetails,
	AccordionSummary,
	Button,
	MenuItem,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableContainer,
	TableHead,
	TablePagination,
	TableRow,
	TableSortLabel,
	TextField,
} from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useHistory, useParams } from 'react-router';
import { Tune } from '@material-ui/icons';
import './consolidatedEInvoice.scss';
import { Footer } from '@ifca-root/react-component/src/components/Footer/Footer';
import { CommonDialog } from '@ifca-root/react-component/src/components/Dialog/CommonDialog';
import CardContents from '@ifca-root/react-component/src/components/CardList/CardContents';
import { KeyboardDatePicker } from '@material-ui/pickers';
import Loading from '@ifca-root/react-component/src/components/Loading/Loading';
import {
	EInvoiceConsolidationTrxType,
	useDocToConsolidateListingLazyQuery,
	useGenerateConsolidatedDocMutation,
	useGetBillQuery,
	useGetOutletQuery,
} from 'generated/graphql';
import { amtStr } from 'helpers/numFormatter';

const dateFormat = require('dateformat');

export const ConsolidatedEInvoiceForm = () => {
	let history = useHistory();

	const { outletID } = useParams<any>();

	const [isExpanded, setIsExpanded] = useState('');
	const [openDialog, setOpenDialog] = useState(false);

	const initialValue = () => {
		const savedFilterArgs = JSON.parse(localStorage.getItem('FilterArgs'));
		return {
			year: savedFilterArgs?.year ?? null,
			month: savedFilterArgs?.month ?? null,
			name: savedFilterArgs?.name ?? null,
			docType:
				savedFilterArgs?.docType ?? EInvoiceConsolidationTrxType?.Invoice,
			docNo: savedFilterArgs?.docNo ?? null,
		};
	};

	const [filterValue, setFilterValue] = useState(initialValue());

	const triggerOpenSearchDialog = () => {
		if (JSON.parse(localStorage.getItem('FilterArgs'))) {
			setFilterValue({
				year: null || JSON.parse(localStorage.getItem('FilterArgs'))?.year,
				month: null || JSON.parse(localStorage.getItem('FilterArgs'))?.month,
				name: null || JSON.parse(localStorage.getItem('FilterArgs'))?.name,
				docType:
					EInvoiceConsolidationTrxType?.Invoice ||
					JSON.parse(localStorage.getItem('FilterArgs'))?.docType,
				docNo: null || JSON.parse(localStorage.getItem('FilterArgs'))?.docNo,
			});
		}
	};

	const {
		called: outletCalled,
		loading: outletLoading,
		error: outletError,
		data: { getOutlet } = { getOutlet: [] },
	} = useGetOutletQuery({
		fetchPolicy: 'network-only',
		variables: { ID: outletID },
	});

	const onSubmitSearch = () => {
		let filter = {};

		filter['year'] = filterValue?.year !== '' ? filterValue?.year : null;
		filter['month'] = filterValue?.month !== '' ? filterValue?.month : null;
		filter['name'] = filterValue?.name !== '' ? filterValue?.name : null;
		filter['docType'] =
			filterValue?.docType !== ''
				? filterValue?.docType
				: EInvoiceConsolidationTrxType?.Invoice;
		filter['docNo'] = filterValue?.docNo !== '' ? filterValue?.docNo : null;

		refetch({
			outletID: outletID,
			accountID: JSON.parse(localStorage.getItem('loggedInUser'))?.accountID,
			year: filter['year'],
			month: filter['month'],
			name: filter['name'],
			docNo: filter['docNo'],
		});
		localStorage.setItem('FilterArgs', JSON.stringify(filter));
	};

	// const {
	// 	loading: billLoading,
	// 	called: billCalled,
	// 	data: { getBill } = { getBill: [] },
	// } = useGetBillQuery({
	// 	fetchPolicy: 'network-only',
	// 	variables: { outletID: outletID },
	// });

	const [
		LoadDocToConsolidateListing,
		{
			refetch,
			loading: DocToConsolidateListingLoading,
			data: { DocToConsolidateListing } = {
				DocToConsolidateListing: {
					consolidatedEIAll: [],
					consolidatedEI: [],
					consolidatedEICount: 0,
					totalPages: 0,
					currentPage: 0,
					total: {
						baseAmount: 0,
						serviceCharge: 0,
						taxAmount: 0,
						docAmount: 0,
					},
				},
			},
		},
	] = useDocToConsolidateListingLazyQuery({
		fetchPolicy: 'no-cache',
	});

	useEffect(() => {
		LoadDocToConsolidateListing({
			variables: {
				outletID: outletID,
				accountID: JSON.parse(localStorage.getItem('loggedInUser'))?.accountID,
				year: null || JSON.parse(localStorage.getItem('FilterArgs'))?.year,
				month: null || JSON.parse(localStorage.getItem('FilterArgs'))?.month,
				name: '' || JSON.parse(localStorage.getItem('FilterArgs'))?.name,
				docNo: null || JSON.parse(localStorage.getItem('FilterArgs'))?.docNo,
				limit: 5,
				offset: offset,
			},
		});
	}, []);

	const handleExpand = panel => (event, newExpanded) => {
		setIsExpanded(newExpanded ? panel : false);
		triggerOpenSearchDialog();
	};

	const [page, setPage] = React.useState(0);
	const [rowsPerPage, setRowsPerPage] = React.useState(5);
	const [offset, setOffset] = React.useState(0);

	const handlePageChange = (event, newPage) => {
		if (newPage > page) {
			setOffset(offset + 5);
		} else if (newPage < page) {
			setOffset(offset - 5);
		}

		setPage(newPage);

		LoadDocToConsolidateListing({
			variables: {
				outletID: outletID,
				accountID: JSON.parse(localStorage.getItem('loggedInUser'))?.accountID,
				year: null || JSON.parse(localStorage.getItem('FilterArgs'))?.year,
				month: null || JSON.parse(localStorage.getItem('FilterArgs'))?.month,
				name: '' || JSON.parse(localStorage.getItem('FilterArgs'))?.name,
				docNo: null || JSON.parse(localStorage.getItem('FilterArgs'))?.docNo,
				limit: 5,
				offset: newPage > page ? offset + 5 : offset - 5,
			},
		});
	};

	const handleChangeRowsPerPage = event => {
		setRowsPerPage(parseInt(event.target.value, 10));
		setPage(0);
	};

	const headCells = [
		{
			ID: 'docDate',
			numeric: false,
			disablePadding: true,
			label: 'Doc Date',
		},
		{
			ID: 'docDate1',
			numeric: false,
			disablePadding: true,
			label: '',
		},
		{
			ID: 'docNo',
			numeric: false,
			disablePadding: false,
			label: 'Doc No',
		},
		{
			ID: 'docType',
			numeric: false,
			disablePadding: false,
			label: 'Doc Type',
		},
		{
			ID: 'name',
			numeric: false,
			disablePadding: false,
			label: 'Name',
		},
		{
			ID: 'baseAmount',
			numeric: true,
			disablePadding: false,
			label: 'Base Amt',
		},
		{
			ID: 'serviceCharge',
			numeric: true,
			disablePadding: false,
			label: 'Service Charge',
		},
		{
			ID: 'taxAmount',
			numeric: true,
			disablePadding: false,
			label: 'Tax Amt',
		},
		{
			ID: 'docAmount',
			numeric: true,
			disablePadding: false,
			label: 'Doc Amt',
		},
	];

	const months = [
		{ value: 1, name: 'January' },
		{ value: 2, name: 'February' },
		{ value: 3, name: 'March' },
		{ value: 4, name: 'April' },
		{ value: 5, name: 'May' },
		{ value: 6, name: 'June' },
		{ value: 7, name: 'July' },
		{ value: 8, name: 'August' },
		{ value: 9, name: 'September' },
		{ value: 10, name: 'October' },
		{ value: 11, name: 'November' },
		{ value: 12, name: 'December' },
	];

	const docType = [
		{ value: 1, name: EInvoiceConsolidationTrxType?.Invoice, label: 'Invoice' },
		{
			value: 2,
			name: EInvoiceConsolidationTrxType?.CreditNote,
			label: 'Credit Note',
		},
	];

	const TableHeader = props => {
		const { orderBy, order, onRequestSort } = props;

		const createSortHandler = property => event => {
			onRequestSort(event, property);
		};

		return (
			<>
				<TableHead>
					<TableRow>
						{headCells?.map(el => {
							return (
								<>
									<TableCell
										key={el?.ID}
										align={el?.numeric ? 'right' : 'left'}
										padding={el?.disablePadding ? 'none' : 'normal'}
										sortDirection={orderBy === el?.ID ? order : false}
										className="tableHead"
									>
										<TableSortLabel
											active={orderBy === el.ID}
											direction={orderBy === el.ID ? order : 'asc'}
											onClick={createSortHandler(el.ID)}
										>
											{el.label}
										</TableSortLabel>
									</TableCell>
								</>
							);
						})}
					</TableRow>
				</TableHead>
			</>
		);
	};

	const TableContent = () => {
		return (
			<>
				<TableBody className="table">
					{DocToConsolidateListing?.consolidatedEI.map(row => {
						return (
							<>
								<TableRow>
									<TableCell
										component="th"
										scope="row"
										align="left"
										className="tableContent"
									>
										{dateFormat(row?.docDate, 'dd/mm/yyyy')}
									</TableCell>
									<TableCell className="tableContent" align="left">
										{''}
									</TableCell>
									<TableCell className="tableContent" align="left">
										{row?.docNo}
									</TableCell>
									<TableCell className="tableContent" align="left">
										{row?.docType}
									</TableCell>
									<TableCell className="tableContent" align="left">
										{row?.name}
									</TableCell>
									<TableCell className="tableContent" align="right">
										{amtStr(row?.baseAmount)}
									</TableCell>
									<TableCell className="tableContent" align="right">
										{amtStr(row?.serviceCharge)}
									</TableCell>
									<TableCell className="tableContent" align="right">
										{amtStr(row?.taxAmount)}
									</TableCell>
									<TableCell className="tableContent" align="right">
										{amtStr(row?.docAmount)}
									</TableCell>
								</TableRow>
							</>
						);
					})}
				</TableBody>
			</>
		);
	};

	window.onbeforeunload = event => {
		localStorage.removeItem('FilterArgs');
	};

	const [
		GenerateConsolidatedDoc,
		{ loading: GenerateConsolidatedDocLoading },
	] = useGenerateConsolidatedDocMutation({
		onCompleted: () => {
			history.push({
				pathname: `/menu/outlet-app/${outletID}/consolidate-e-inovoice`,
			});
		},
	});

	let amount = 0,
		serviceCharge = 0,
		taxAmt = 0,
		docAmt = 0;
	DocToConsolidateListing?.consolidatedEI?.map(x => {
		amount += x?.baseAmount;
		serviceCharge += x?.serviceCharge;
		taxAmt += x?.taxAmount;
		docAmt += x?.docAmount;
	});

	const [docDate, SetDocDate] = useState(new Date());
	const [description, SetDescription] = useState('');

	const onSubmit = () => {
		GenerateConsolidatedDoc({
			variables: {
				outletID: outletID,
				accountID: JSON.parse(localStorage.getItem('loggedInUser'))?.accountID,
				companyID: getOutlet[0]?.companyID,
				year: null || JSON.parse(localStorage.getItem('FilterArgs'))?.year,
				month: null || JSON.parse(localStorage.getItem('FilterArgs'))?.month,
				name: '' || JSON.parse(localStorage.getItem('FilterArgs'))?.name,
				docNo: null || JSON.parse(localStorage.getItem('FilterArgs'))?.docNo,
				limit: 5,
				offset: offset,
				trxDate: new Date(),
				docDate: dateFormat(docDate, 'yyyy-mm-dd'),
				description: description,
			},
		});
	};

	return (
		<>
			{DocToConsolidateListingLoading && <Loading />}

			<MainHeader
				onClick={() => {
					history.push({
						pathname: `/menu/outlet-app/${outletID}/consolidate-e-inovoice`,
					});
				}}
				mainBtn="back"
				smTitle="Outlet App"
				title={getOutlet[0]?.name}
				routeSegments={[
					{ name: 'Consolidated e-Invoice' },
					{ name: 'Consolidated e-Invoice', current: true },
				]}
			/>

			<DynamicSubHeader
				title={
					<span className="display-flex">
						<span className="xsTitle color-primary-orange flex-space">
							Consolidated e-Invoice
						</span>
					</span>
				}
			/>

			<ContentWrapper singleDynamicInfo style={{ marginTop: '30px' }}>
				<Accordion
					expanded={isExpanded === 'panel1'}
					onChange={handleExpand('panel1')}
					className="accordion-consolidatedEI"
				>
					<AccordionSummary
						expandIcon={<Tune />}
						aria-controls="panel1a-content"
						id="panel1a-header"
						style={{ backgroundColor: '#fef1de' }}
					>
						<div className="flex">
							<span
								className="flex-space xsTitle margin-auto"
								style={{ fontSize: '11px', color: '#ff9800' }}
							>
								{`Advance Search`}
							</span>
						</div>
					</AccordionSummary>

					<AccordionDetails>
						<TextField
							className="left advanceSearch"
							fullWidth
							label="Year"
							InputLabelProps={{ style: { fontSize: '11px' } }}
							value={filterValue?.year || ''}
							onChange={e =>
								setFilterValue({
									...filterValue,
									year: parseFloat(e.target.value),
								})
							}
						/>

						<TextField
							className="right advanceSearch"
							fullWidth
							select
							label="Month"
							InputLabelProps={{ style: { fontSize: '11px' } }}
							value={filterValue?.month || ''}
							onChange={e =>
								setFilterValue({
									...filterValue,
									month: e.target.value,
								})
							}
						>
							{months?.map(el => (
								<MenuItem key={el?.value} value={el?.name}>
									{el?.name}
								</MenuItem>
							))}
						</TextField>

						<TextField
							className="left advanceSearch"
							fullWidth
							label="Name"
							InputLabelProps={{ style: { fontSize: '11px' } }}
							value={filterValue?.name || ''}
							onChange={e =>
								setFilterValue({
									...filterValue,
									name: e.target.value,
								})
							}
						/>

						<TextField
							className="left advanceSearch"
							fullWidth
							select
							label="Doc Type"
							InputLabelProps={{ style: { fontSize: '11px' } }}
							value={
								filterValue?.docType || EInvoiceConsolidationTrxType?.Invoice
							}
							onChange={e =>
								setFilterValue({
									...filterValue,
									docType: e.target.value,
								})
							}
						>
							{docType?.map(el => (
								<MenuItem key={el?.value} value={el?.name}>
									{el?.label}
								</MenuItem>
							))}
						</TextField>

						<TextField
							className="left advanceSearch"
							fullWidth
							label="Doc No"
							InputLabelProps={{ style: { fontSize: '11px' } }}
							value={filterValue?.docNo || ''}
							onChange={e =>
								setFilterValue({
									...filterValue,
									docNo: e.target.value,
								})
							}
						/>

						<div
							style={{
								display: 'flex',
								justifyContent: 'flex-end',
								gap: '10px',
								marginTop: '10px',
								width: '100%',
							}}
						>
							<Button
								variant="contained"
								color="secondary"
								style={{ fontSize: '11px' }}
								onClick={() => {
									localStorage.removeItem('FilterArgs');
									const resetValue = initialValue();
									setFilterValue(resetValue);
									setIsExpanded('');
								}}
							>
								Reset
							</Button>
							<Button
								variant="contained"
								color="primary"
								style={{ fontSize: '11px' }}
								onClick={() => {
									onSubmitSearch();
									setIsExpanded('');
								}}
							>
								Filter
							</Button>
						</div>
					</AccordionDetails>
				</Accordion>
			</ContentWrapper>

			<ContentWrapper footer style={{ marginTop: '0px' }}>
				<div style={{ width: '100%' }}>
					<Paper style={{ width: '100%' }}>
						<TableContainer>
							<Table style={{ minWidth: 750 }}>
								<TableHeader />

								{!DocToConsolidateListingLoading && <TableContent />}

								<TableBody>
									<TableRow>
										<TableCell className="tableHead">{`Total record: ${DocToConsolidateListing?.consolidatedEICount}`}</TableCell>
										<TableCell className="tableHead">{''}</TableCell>
										<TableCell className="tableHead">{''}</TableCell>
										<TableCell className="tableHead">{''}</TableCell>
										<TableCell className="tableHead">Total</TableCell>
										<TableCell className="tableHead" align="right">
											{amtStr(DocToConsolidateListing?.total?.baseAmount)}
										</TableCell>
										<TableCell className="tableHead" align="right">
											{amtStr(DocToConsolidateListing?.total?.serviceCharge)}
										</TableCell>
										<TableCell className="tableHead" align="right">
											{amtStr(DocToConsolidateListing?.total?.taxAmount)}
										</TableCell>
										<TableCell className="tableHead" align="right">
											{amtStr(DocToConsolidateListing?.total?.docAmount)}
										</TableCell>
									</TableRow>
								</TableBody>
							</Table>
						</TableContainer>

						<TablePagination
							rowsPerPageOptions={[5, 10, 25]}
							component="div"
							count={DocToConsolidateListing?.consolidatedEICount}
							rowsPerPage={rowsPerPage}
							page={page}
							onPageChange={handlePageChange}
							onRowsPerPageChange={handleChangeRowsPerPage}
						/>
					</Paper>
				</div>
			</ContentWrapper>

			<Footer
				options={[
					{
						name: 'Send to LHDN',
						onClick: () => {
							setOpenDialog(true);
						},
						color: 'primary',
						disabled: false,
					},
				]}
			/>

			<CommonDialog
				fullWidth={true}
				open={openDialog}
				onClose={() => setOpenDialog(false)}
				sections={{
					header: {
						dynamic: (
							<>
								<div className="dialog-dynamic-content">
									<div className="session">
										<div className="flex session">
											<div className="xsTitle color-primary-orange flex-space">
												Consolidated e-Invoice
											</div>
										</div>
									</div>
								</div>
							</>
						),
					},
					body: () => (
						<>
							<CardContents>
								<span className="content-wrap full">
									<span className="mdDesc">
										{`Invoice (${DocToConsolidateListing?.consolidatedEICount})`}
									</span>
									<span
										className="mdDesc"
										style={{ float: 'right', marginTop: '7px' }}
									>
										{amtStr(DocToConsolidateListing?.total?.docAmount)}
									</span>
								</span>
								<KeyboardDatePicker
									value={new Date()}
									margin="normal"
									autoOk
									label="Document Date"
									required
									onChange={date => {
										SetDocDate(date);
									}}
									format="dd/MM/yyyy"
								/>
								<TextField
									fullWidth
									multiline
									label="Description"
									onChange={e => {
										SetDescription(e.target.value);
									}}
								/>
							</CardContents>
						</>
					),
					footer: {
						actions: [
							{
								displayText: 'Cancel',
								props: {
									onClick: () => {
										setOpenDialog(false);
									},
									variant: 'contained',
									color: 'primary',
								},
							},
							{
								displayText: 'Proceed',
								props: {
									onClick: () => {
										onSubmit();
										setOpenDialog(false);
									},
									variant: 'contained',
									color: 'primary',
								},
							},
						],
					},
				}}
			/>
		</>
	);
};
